// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___3tsEv","open":"open___2OCRt","dataTable":"dataTable___1rl4d"};